const resultFunction = (availability) => {
    return availability;
};
const availabilitySelectorDefinition = {
    id: 'swapAvailability',
    resultFunction,
    dependencies: [{ selector: 'availability' }],
};
export default availabilitySelectorDefinition;
